$(function() {

	if (getCookie('cookie') == "open") {

		$(".c-contact-person").addClass("close");

	}

	$(".c-contact-person__button-close").click(function(){

		$(".c-contact-person").addClass("close");

		setCookie('cookie','close',7);


	});

	$(".c-contact-person__button-open").click(function(){

		$(".c-contact-person").removeClass("close");

		setCookie('cookie','open',7);


	});



		var width = $(document).width();

		if (width < 576) {

			$('.c-contact-person').hide();

			$(document).scroll(function () {
				if ($(this).scrollTop() >= $('.c-product-hero__card__inner').offset().top) {
					$('.c-contact-person').show();
				} else {
					$('.c-contact-person').hide();
				}

			});

		}else {

		}


});

function setCookie(name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
